import React, { Component } from "react";
import PropTypes from "prop-types";
import { Checkbox, Modal, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";

const FIELDS_OPTIONS = [
  { label: "Description", value: "description" },
  { label: "Claims", value: "claims" },
  { label: "Abstract", value: "abstract_fulltext" },
  { label: "Title", value: "title" },
  { label: "Non Patent Citations", value: "non_patent_citations" }
];

class SearchIn extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    searchIn: PropTypes.array,
    disabled: PropTypes.bool
  };

  state = {
    searchIn: this.props.searchIn,
    visible: false
  };
  render() {
    return (
      <>
        <Button size="small" icon={<FilterOutlined />} disabled={this.props.disabled} onClick={this._showModal} style={this.props.style} />
        <Modal title="Select the fields to search in" open={this.state.visible} onCancel={this._onCancel} onOk={this._onOk}>
          <Checkbox.Group options={FIELDS_OPTIONS} value={this.state.searchIn || FIELDS_OPTIONS.map(opt => opt.value)} onChange={this._onCheckboxChange} />
        </Modal>
      </>
    );
  }

  _showModal = () => {
    this.setState({ visible: true });
  };

  _onCancel = () => {
    this.setState({ visible: false });
  };

  _onCheckboxChange = val => {
    this.setState({ searchIn: val });
  };

  _onOk = () => {
    this.setState({ visible: false });
    this.props.onChange(this.state.searchIn);
  };
}

export default SearchIn;
